import { sendEvent, sendException } from 'helpers/analytics';
import {
  getChannelContextCode,
  getChannelContextMsg,
  getJsonStringify
} from 'helpers/Utility';
import { setError, setHomePath } from 'store/actions/auth';
import { setIsSameContactOther } from 'store/actions/loanApply';

/**
 * to handle error from credit scoring 2nd loan
 * @param {*} dispatch
 * @param {*} err
 * @param {*} phoneNo
 * @returns
 */
export const handleSecondLoanCreditScoringError = (dispatch, err, phoneNo) => {
  dispatch(setHomePath('/continue-apply'));

  if (!err.response) {
    return dispatch(setError('connection'));
  }

  // Mapping error code → error type
  const errorMap = {
    211053: 'error_minimum_balance', // saving amount <= 0
    11017: 'same-phonenum-relationship',
    211051: 'OCR_FAILED',
    211101: 'PAYROLL_ERROR',
    1021: 'error_postalcode_district',
    1022: 'error_postalcode_ktp',
    1023: 'error_postalcode_company',
  };

  // Direct map lookup
  if (errorMap[getChannelContextCode(err, 'channel-context')]) {
    dispatch(setError(errorMap[getChannelContextCode(err, 'channel-context')]));
    if (getChannelContextCode(err, 'channel-context') === '11018') {
      dispatch(setIsSameContactOther(true));
    }
    return;
  }

  // Special handling
  if (
    getChannelContextCode(err, 'channel-context') === '1005' ||
    getChannelContextCode(err, 'channel-context') === '1006' ||
    getChannelContextMsg(err, 'channel-context')?.includes(
      'No data found on ececuser.commoncodes'
    )
  ) {
    return dispatch(setError('error_cocd'));
  }

  if (getChannelContextCode(err, 'channel-context') === '11018') {
    dispatch(setError('same-phonenum-other'));
    dispatch(setIsSameContactOther(true));
    return;
  }

  if (
    err.code === 'ERR_BAD_REQUEST' ||
    getChannelContextCode(err, 'channel-context') === null
  ) {
    return dispatch(setError('system'));
  }

  // Fallback → system error + logging
  dispatch(setError('system'));
  sendEvent({
    category: 'Unexpected Error Credit Scoring 2nd Loan',
    action: getJsonStringify(err.response),
    label: phoneNo
  });
  sendException({
    desc: getJsonStringify(err.response),
    fatal: true
  });
};
